// STATUS: draft — needs native-speaker check before live
// Italian visitor messages (task TR1, docs/modules/languages.md s2). Formal "Lei" forms. Visitor keys only; missing keys fall back to en-GB.
export const itVisitor = {
    'kiosk.pairing.title': 'Configuri questo chiosco',
    'kiosk.pairing.hint': 'Inserisca il codice del portale CloudSign.',
    'kiosk.pairing.go': 'Associa',
    'kiosk.pairing.codeLabel': 'Codice di associazione',
    'kiosk.pairing.checking': 'Verifica del codice…',
    'kiosk.pairing.clear': 'Cancella',
    'kiosk.pairing.back': 'Cancella l’ultima cifra',
    'kiosk.pairing.invalid': 'Questo codice non è valido o è scaduto. Ne chieda uno nuovo.',
    'kiosk.pairing.noNetwork': 'Impossibile raggiungere CloudSign. Controlli il Wi-Fi e riprovi.',
    'kiosk.common.back': 'Indietro',
    'kiosk.common.next': 'Avanti',
    'kiosk.common.continue': 'Continua',
    'kiosk.common.cancel': 'Annulla',
    'kiosk.common.yes': 'Sì',
    'kiosk.common.no': 'No',
    'kiosk.welcome.tap': 'Tocchi qui per registrare l’ingresso o l’uscita',
    'kiosk.welcome.offline': 'Offline: le registrazioni vengono salvate e inviate più tardi',
    'kiosk.home.title': 'Cosa desidera fare?',
    'kiosk.home.signIn': 'Registri l’ingresso',
    'kiosk.home.signOut': 'Registri l’uscita',
    'kiosk.home.scan': 'Scansioni il mio badge',
    'kiosk.groups.titleIn': 'Con quale ruolo si registra?',
    'kiosk.groups.titleOut': 'Con quale ruolo registra l’uscita?',
    'kiosk.groups.hint': 'Scelga l’opzione che Le corrisponde meglio.',
    'kiosk.groups.repeat': 'Membri abituali',
    'kiosk.pin.hint': 'Inserisca il PIN di 4 cifre.',
    'kiosk.pin.entered': '{count} cifre su 4 inserite',
    'kiosk.pin.wrong': 'Il PIN non è corretto. Riprovi.',
    'kiosk.pin.locked': 'Troppi PIN errati. L’inserimento del PIN è bloccato per alcuni minuti. Chieda aiuto a qualcuno.',
    'kiosk.pin.clear': 'Cancella',
    'kiosk.pin.back': 'Cancella l’ultima cifra',
    'kiosk.identify.title': 'Trovi il Suo nome',
    'kiosk.identify.placeholder': 'Inizi a scrivere il Suo nome',
    'kiosk.identify.none': 'Nessuno trovato con questo nome.',
    'kiosk.identify.addSelf': 'Non sono nell’elenco',
    'kiosk.addSelf.title': 'Si aggiunga',
    'kiosk.name.title': 'Qual è il Suo nome?',
    'kiosk.name.label': 'Il Suo nome',
    'kiosk.name.fullNameHint': 'Indichi il nome e il cognome.',
    'kiosk.already.message': 'Il Suo ingresso è già registrato. Vuole registrare invece l’uscita?',
    'kiosk.already.signOut': 'Registri la mia uscita',
    'kiosk.questions.titleIn': 'Alcune brevi domande',
    'kiosk.questions.titleOut': 'Prima di andare',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'Ho capito',
    'kiosk.questions.hostSearch': 'Scriva il nome della persona che sta visitando',
    'kiosk.questions.changeHost': 'Modifica',
    'kiosk.notices.progress': 'Avviso {n} di {total}',
    'kiosk.notices.accept': 'Ho letto questo avviso e lo accetto',
    'kiosk.notices.sign': 'Firmi',
    'kiosk.notices.signHere': 'Firmi con il dito, per favore.',
    'kiosk.signature.pad': 'Riquadro della firma',
    'kiosk.signature.clear': 'Cancella firma',
    'kiosk.signature.captured': 'Firma salvata',
    'kiosk.photo.title': 'Foto',
    'kiosk.photo.hint': 'Guardi la fotocamera e tocchi il pulsante.',
    'kiosk.photo.take': 'Scatti la mia foto',
    'kiosk.photo.getReady': 'Si prepari…',
    'kiosk.photo.retake': 'Scatti di nuovo',
    'kiosk.photo.use': 'Usi questa foto',
    'kiosk.photo.skip': 'Salti la foto',
    'kiosk.photo.failed': 'La foto non è riuscita. Riprovi.',
    'kiosk.photo.noCamera': 'La fotocamera non è disponibile. Può continuare senza foto.',
    'kiosk.photo.privacy': 'La Sua foto viene usata solo per il badge e per la scheda della visita.',
    'kiosk.badge.title': 'Il Suo badge',
    'kiosk.badge.ask': 'Desidera un badge?',
    'kiosk.badge.yes': 'Stampi il mio badge',
    'kiosk.badge.no': 'No, grazie',
    'kiosk.badge.printing': 'Stampa del badge in corso…',
    'kiosk.badge.done': 'Ritiri il Suo badge',
    'kiosk.badge.failed': 'Spiacenti, il badge non è stato stampato. Il Suo ingresso è registrato. Chieda un badge alla reception.',
    'kiosk.signout.title': 'Trovi il Suo nome per registrare l’uscita',
    'kiosk.signout.search': 'Cerca per nome',
    'kiosk.signout.hiddenHint': 'Per motivi di privacy i nomi non vengono mostrati. Scriva il Suo nome o scansioni il badge.',
    'kiosk.signout.empty': 'Nessuno è registrato.',
    'kiosk.signout.noMatch': 'Nessuno trovato. Riprovi o scansioni il badge.',
    'kiosk.signout.unnamed': 'Visitatore',
    'kiosk.scan.title': 'Scansioni il Suo badge',
    'kiosk.scan.hint': 'Tenga il codice QR del badge davanti alla fotocamera.',
    'kiosk.scan.allow': 'Consenta la fotocamera',
    'kiosk.scan.noCamera': 'La fotocamera non è disponibile. Scelga il Suo nome dall’elenco.',
    'kiosk.scan.notBadge': 'Questo non è un badge CloudSign. Riprovi.',
    'kiosk.scan.notSignedIn': 'Questo badge non è registrato qui. Scelga il Suo nome dall’elenco.',
    'kiosk.finish.inTitle': 'Grazie, {name}',
    'kiosk.finish.inMessage': 'Il Suo ingresso è registrato.',
    'kiosk.finish.outTitle': 'Arrivederci, {name}',
    'kiosk.finish.outMessage': 'La Sua uscita è registrata. Buon viaggio!',
    'kiosk.finish.tap': 'Tocchi per terminare',
    'kiosk.update.title': 'Questo chiosco deve essere aggiornato',
    'kiosk.update.message': 'Questo chiosco deve essere aggiornato prima di poter registrare il Suo ingresso. Chieda alla reception.',
    'kiosk.update.short': 'Aggiornamento richiesto',
    'kiosk.error.required': 'Risponda a questa domanda, per favore.',
    'kiosk.error.mustAcknowledge': 'Spunti la casella per confermare.',
    'kiosk.error.nameRequired': 'Scriva il Suo nome, per favore.',
    'kiosk.error.fullName': 'Indichi il nome e il cognome.',
    'kiosk.error.tooLong': 'Questa risposta è troppo lunga.',
    'kiosk.error.number': 'Inserisca un numero.',
    'kiosk.error.wholeNumber': 'Inserisca un numero intero.',
    'kiosk.error.range': 'Questo numero non rientra nell’intervallo consentito.',
    'kiosk.error.email': 'Inserisca un indirizzo e-mail valido.',
    'kiosk.error.phone': 'Inserisca un numero di telefono valido.',
    'kiosk.error.date': 'Inserisca una data nel formato 2026-12-31.',
    'kiosk.error.answerNotAllowed': 'Con questa risposta non può registrarsi qui. Si rivolga alla reception.',
    'kiosk.print.state.ready': 'La stampante è pronta',
    'kiosk.print.state.no_media': 'La stampante ha esaurito le etichette',
    'kiosk.print.state.cover_open': 'Il coperchio della stampante è aperto',
    'kiosk.print.state.media_mismatch': 'Nella stampante sono caricate le etichette sbagliate',
    'kiosk.print.state.busy': 'La stampante è occupata',
    'kiosk.print.state.error': 'La stampante segnala un problema',
    'kiosk.print.state.unreachable': 'Impossibile raggiungere la stampante',
    'kiosk.print.state.unknown': 'Stato della stampante sconosciuto',
    'kiosk.home.expected': 'Sono atteso',
    'kiosk.home.scanCode': 'Scansioni il mio codice QR',
    'kiosk.scan.titleCode': 'Scansioni il Suo codice QR',
    'kiosk.scan.hintCode': 'Tenga davanti alla fotocamera il codice QR dell’e-mail, della tessera o del badge.',
    'kiosk.scan.invalid': 'Questo codice QR non è valido qui. Riprovi o scelga il Suo nome dall’elenco.',
    'kiosk.scan.notSupported': 'Questo chiosco non può usare questo tipo di codice QR. Scelga il Suo nome dall’elenco.',
    'kiosk.scan.unknownMember': 'Questo codice QR non è riconosciuto da questo chiosco. Scelga il Suo nome dall’elenco.',
    'kiosk.scan.oldCode': 'Questo codice QR è stato sostituito da uno nuovo. Usi il più recente oppure scelga il Suo nome.',
    'kiosk.scan.notHere': 'Questo codice QR non è per questo chiosco.',
    'kiosk.scan.notExpected': 'Oggi non è attesa questa persona. Chieda alla reception.',
    'kiosk.scan.cancelled': 'Questa visita è stata annullata. Chieda alla reception.',
    'kiosk.scan.alreadyArrived': 'Questo codice QR è già stato usato per registrare un ingresso.',
    'kiosk.scan.expired': 'Questo codice QR è scaduto. Chieda alla reception.',
    'kiosk.expected.title': 'Chi è?',
    'kiosk.expected.search': 'Inizi a scrivere il Suo nome',
    'kiosk.expected.exactHint': 'Scriva il Suo nome completo esattamente come ci è stato comunicato.',
    'kiosk.expected.requiredHint': 'Per registrarsi qui è necessario essere attesi. Trovi il Suo nome o scansioni il codice QR.',
    'kiosk.expected.none': 'Non abbiamo trovato questo nome nell’elenco di oggi. Chieda alla reception.',
    'kiosk.expected.empty': 'Al momento non è atteso nessuno.',
    'kiosk.expected.visiting': 'In visita a {host}',
    'kiosk.expected.required': 'Per registrarsi qui è necessario essere attesi. Chieda alla reception.',
    'kiosk.signout.outMark': 'Uscito',
    'kiosk.signout.outToday': 'Uscita registrata oggi',
    'kiosk.hostReply.on_my_way': '{host} sta arrivando.',
    'kiosk.hostReply.please_wait': '{host} La prega di attendere.',
    'kiosk.hostReply.someone': 'Il Suo referente',
    'kiosk.hostReply.dismiss': 'OK',
    'kiosk.evacuation.notAllowed': 'Da questo chiosco non è possibile avviare un’evacuazione.',
    'kiosk.evacuation.wrongPin': 'Il PIN non è corretto.',
    'kiosk.evacuation.pinLocked': 'Troppi PIN errati. Attenda alcuni minuti.',
    'kiosk.evacuation.startFailed': 'Impossibile avviare l’evacuazione. Riprovi.',
    'kiosk.nfc.enrolOffline': 'Questo chiosco è offline. Le tessere possono essere registrate solo quando è online.',
    'kiosk.nfc.enrolExpired': 'Questa registrazione della tessera è terminata o scaduta.',
    'kiosk.nfc.enrolFailed': 'Impossibile registrare questa tessera. Ne provi un’altra.',
    'kiosk.nfc.enrolTapAgain': 'Avvicini di nuovo la tessera, per favore.',
    'kiosk.common.ok': 'OK',
    'kiosk.welcome.stale': 'Questo chiosco è rimasto offline a lungo. Informi la reception, per favore.',
    'kiosk.welcome.busy': 'Al momento la sede è molto affollata. Se è in visita, informi la reception, per favore.',
    'kiosk.welcome.evacuation': 'Evacuazione',
    'kiosk.home.delivery': 'Sono qui per consegnare un pacco',
    'kiosk.check.seeReceptionTitle': 'Si rivolga alla reception, per favore',
    'kiosk.check.warnTitle': 'Prima di continuare',
    'kiosk.full.short': 'La sede è al completo',
    'kiosk.full.title': 'La sede è al completo',
    'kiosk.full.message': 'Al momento non possiamo registrare altri visitatori. Si rivolga alla reception, per favore.',
    'kiosk.induction.subtitle': 'Formazione di accesso alla sede',
    'kiosk.induction.unavailable': 'La formazione di accesso non è disponibile su questo chiosco. Si rivolga alla reception.',
    'kiosk.induction.videoMissing': 'Il video non è ancora presente su questo chiosco. Legga il testo qui sotto, per favore.',
    'kiosk.induction.pdfNote': 'Legga il testo della formazione qui sotto. Chieda alla reception se desidera il documento.',
    'kiosk.induction.wait': 'Attenda {seconds} secondi, per favore',
    'kiosk.induction.startQuiz': 'Inizia le domande',
    'kiosk.induction.question': 'Domanda {n} di {total}',
    'kiosk.induction.chooseMany': 'Scelga tutte le risposte corrette.',
    'kiosk.induction.finish': 'Fine',
    'kiosk.induction.retryTitle': 'Non ancora',
    'kiosk.induction.retryMessage': 'Alcune risposte non erano corrette. Riprovi {count}.',
    'kiosk.induction.retryButton': 'Riprova',
    'kiosk.permits.title': 'I Suoi permessi di lavoro',
    'kiosk.permits.unavailable': 'I permessi non possono essere mostrati in questo momento. Si rivolga alla reception prima di iniziare il lavoro.',
    'kiosk.permits.allAccepted': 'Ha accettato tutti i Suoi permessi.',
    'kiosk.permits.progress': 'Permesso {n} di {total}',
    'kiosk.permits.valid': 'Dal {from} al {until}',
    'kiosk.permits.conditions': 'Condizioni',
    'kiosk.permits.precautions': 'Precauzioni',
    'kiosk.permits.signHere': 'Firmi qui per accettare, {name}',
    'kiosk.permits.accept': 'Accetto questo permesso',
    'kiosk.nfc.blocked': 'Questa tessera è stata bloccata',
    'kiosk.nfc.unknown': 'Tessera non riconosciuta',
    'kiosk.nfc.enrolTitle': 'Registrazione delle tessere',
    'kiosk.nfc.enrolProgress': '{done} di {total} completate',
    'kiosk.nfc.enrolTapFor': 'Avvicini la tessera per',
    'kiosk.nfc.enrolHold': 'Tenga la tessera contro il retro del tablet.',
    'kiosk.nfc.enrolSaving': 'Salvataggio in corso…',
    'kiosk.nfc.enrolOk': 'Tessera salvata.',
    'kiosk.nfc.enrolDone': 'Tutte le tessere sono registrate',
    'kiosk.nfc.noReader': 'Nessun lettore di tessere è attivo su questo chiosco.',
    'kiosk.evacuation.title': 'EVACUAZIONE',
    'kiosk.evacuation.drillTitle': 'ESERCITAZIONE ANTINCENDIO',
    'kiosk.evacuation.startTitle': 'Avvia un’evacuazione',
    'kiosk.evacuation.confirmTitle': 'Avviare un’evacuazione?',
    'kiosk.evacuation.confirmMessage': 'Questo avvisa tutte le persone presenti nella sede e apre l’appello.',
    'kiosk.evacuation.confirmStart': 'Avvia evacuazione',
    'kiosk.evacuation.leave': 'Esci dall’appello',
    'kiosk.evacuation.leaveTitle': 'Inserisca il PIN per uscire dall’appello',
    'kiosk.evacuation.returnBanner': 'Evacuazione in corso. Tocchi per tornare all’appello.',
    'kiosk.evacuation.offline': 'Offline: le sue segnalazioni vengono salvate e inviate quando la rete tornerà disponibile.',
    'kiosk.evacuation.localOnly': 'Avviata su questo chiosco offline. Sarà unita al portale quando la rete tornerà disponibile.',
    'kiosk.evacuation.countUnaccounted': 'Non ancora trovati',
    'kiosk.evacuation.countSafe': 'Al sicuro',
    'kiosk.evacuation.countMissing': 'Dispersi',
    'kiosk.evacuation.countTotal': 'Nella sede',
    'kiosk.evacuation.allPoints': 'Tutti',
    'kiosk.evacuation.search': 'Cerca per nome',
    'kiosk.evacuation.onlyOpen': 'Non ancora al sicuro',
    'kiosk.evacuation.loading': 'Caricamento dell’appello…',
    'kiosk.evacuation.nobody': 'Nessuno da mostrare.',
    'kiosk.evacuation.safe': 'Al sicuro',
    'kiosk.evacuation.markedSafe': 'AL SICURO (tocchi per annullare)',
    'kiosk.evacuation.missing': 'Disperso',
    'kiosk.evacuation.markedMissing': 'DISPERSO (tocchi per annullare)',
    'kiosk.evacuation.host': 'Referente: {name}',
    'kiosk.evacuation.check': 'VERIFICARE',
    'kiosk.evacuation.permits': '{count} permesso/i aperto/i',
    'kiosk.contactless.qrLabel': 'Scansioni questo codice con il telefono per registrare l’ingresso',
    'kiosk.contactless.scanMe': 'Registri l’ingresso con il telefono',
    'kiosk.courier.whoTitle': 'Per chi è il pacco?',
    'kiosk.courier.whoHint': 'Scriva alcune lettere del nome.',
    'kiosk.courier.search': 'Nome della persona',
    'kiosk.courier.useName': 'Usa «{name}»',
    'kiosk.courier.useNameHint': 'La reception lo consegnerà',
    'kiosk.courier.carrierTitle': 'Di quale società è?',
    'kiosk.courier.forName': 'Pacco per {name}',
    'kiosk.courier.other': 'Altra',
    'kiosk.courier.otherLabel': 'Nome della società',
    'kiosk.courier.countTitle': 'Quanti pacchi?',
    'kiosk.courier.howMany': 'Numero di pacchi',
    'kiosk.courier.save': 'Fatto',
    'kiosk.courier.thanks': 'Grazie',
    'kiosk.courier.thanksMessage': 'Abbiamo avvisato il destinatario che il pacco è arrivato.',
    'kiosk.support.pinTitle': 'Assistenza: inserisca il PIN',
    'kiosk.support.title': 'Assistenza',
    'kiosk.support.close': 'Chiudi',
    'kiosk.support.network': 'Rete',
    'kiosk.support.online': 'Online',
    'kiosk.support.offline': 'Offline',
    'kiosk.support.queue': 'In attesa di invio',
    'kiosk.support.oldest': 'Il più vecchio in attesa da',
    'kiosk.support.none': 'Nessuno',
    'kiosk.support.deadLetters': 'Rifiutati dal server (non inviati)',
    'kiosk.support.deadHelp': 'Questi elementi sono stati rifiutati dal server e restano su questo chiosco. Informi l’amministratore; la pagina del dispositivo nel portale ne mostra il numero.',
    'kiosk.support.configAge': 'Impostazioni aggiornate l’ultima volta',
    'kiosk.support.ageUnknown': 'Mai',
    'kiosk.support.ageMinutes': '{n} minuti fa',
    'kiosk.support.ageHours': '{n} ore fa',
    'kiosk.support.ageDays': '{n} giorni fa',
    'kiosk.support.nfc': 'Lettore di tessere',
    'kiosk.support.nfcReady': 'Pronto',
    'kiosk.support.nfcOff': 'Disattivato',
    'kiosk.support.nfcNone': 'Non installato',
    'kiosk.support.media': 'Video memorizzati',
    'kiosk.support.mediaMb': '{mb} MB',
    'kiosk.support.headcount': 'Persone nella sede (questo chiosco)',
    'kiosk.finish.poweredBy': 'Realizzato con CloudSign',
    'kiosk.badge.noMedia': 'La stampante dei badge ha esaurito le etichette. Il Suo ingresso è registrato. Informi la reception, per favore.',
    'kiosk.badge.mediaMismatch': 'Nella stampante dei badge sono caricate le etichette sbagliate. Il Suo ingresso è registrato. Informi la reception, per favore.',
    'kiosk.badge.coverOpen': 'Il coperchio della stampante dei badge è aperto. Il Suo ingresso è registrato. Informi la reception, per favore.',
    'kiosk.member.menuTitle': 'Cosa desidera fare?',
    'kiosk.member.signIn': 'Registri il mio ingresso',
    'kiosk.member.updatePhoto': 'Aggiorni la mia foto',
    'kiosk.member.sendInvite': 'Mi invii l’invito all’app',
    'kiosk.memberPhoto.title': 'Aggiorni la Sua foto',
    'kiosk.memberPhoto.saved': 'La Sua foto è stata aggiornata.',
    'kiosk.memberPhoto.failed': 'Non è stato possibile salvare la foto. Riprovi o chieda alla reception.',
    'kiosk.memberPhoto.offline': 'Questo chiosco è offline, quindi la foto non può essere aggiornata al momento.',
    'kiosk.memberPhoto.notAllowed': 'La foto non può essere aggiornata sul chiosco. Chieda alla reception.',
    'kiosk.invite.title': 'Ottenga l’app CloudSign',
    'kiosk.invite.sent': 'Le abbiamo inviato via e-mail un link per configurare l’app. Controlli la posta in arrivo.',
    'kiosk.invite.noEmail': 'Non abbiamo il Suo indirizzo e-mail, quindi non è stato possibile inviare l’invito. Chieda alla reception.',
    'kiosk.invite.tooMany': 'Oggi sono stati richiesti troppi inviti. Riprovi domani.',
    'kiosk.invite.failed': 'Impossibile inviare l’invito. Riprovi o chieda alla reception.',
    'kiosk.invite.offline': 'Questo chiosco è offline, quindi al momento non è possibile inviare un invito.',
    'kiosk.invite.sending': 'Invio del Suo invito…',
    'kiosk.language.choose': 'Scelga la lingua',
    'kiosk.language.button': 'Lingua',
    'public.language.label': 'Lingua',
    'contactless.thank_you': 'Grazie. Il Suo ingresso è registrato.',
    'contactless.thank_you_out': 'Grazie. La Sua uscita è registrata.',
    'contactless.poster.title': 'Scansioni per registrare l’ingresso',
    'contactless.poster.hint': 'Punti la fotocamera del telefono sul codice. Non serve alcuna app.',
    'check.safety_check.refused': 'Si rivolga alla reception prima di registrare l’ingresso.',
    'check.safety_check.alert': 'Ammesso con un avviso alla reception (controllo di sicurezza).',
    'check.compliance.refused': 'Manca un documento obbligatorio o è scaduto. Si rivolga alla reception, per favore.',
    'check.compliance.warned': 'Manca un documento obbligatorio o è scaduto.',
    'check.induction.required': 'Completi prima la formazione di accesso alla sede.',
    'check.capacity.full': 'La sede è al completo in questo momento. Si rivolga alla reception, per favore.',
    'check.capacity.warned': 'Registrato mentre la sede superava la capienza.',
    'check.offline': 'Registrato mentre il chiosco era offline.',
};
//# sourceMappingURL=it.js.map